import { v4 as uuidv4 } from "uuid";
import { CalendarApi } from "api/calendarApi";
import { useCalendar } from "api/hooks";
import React, { useMemo, useState } from "react";
import { CalendarEvent } from "./CalendarDayCard";
import { EmptyState, PageMain } from "components/molecules";
import { SelectedCalendarDayPanel } from "./SelectedCalendarDayPanel";
import { PaziaLoader } from "components/atoms";
import { MonthCalendar } from "./MonthCalendar";
import { FaLaptop } from "react-icons/fa6";
import { DashboardNotifications } from "./DashboardNotifications";

type SelectedDay = {
  date: {
    day: number;
    month: number;
    year: number;
  };
  events: CalendarEvent[];
};

export function DashboardPage() {
  const [selected, setSelected] = useState<SelectedDay | null>(null);
  const { loading, data } = useCalendar();

  const events = useMemo(() => (data ? mapEvents(data) : []), [data]);

  const onMoreEventsClick = (
    date: {
      day: number;
      month: number;
      year: number;
    },
    events: CalendarEvent[],
  ) => setSelected({ date, events });

  if (loading) return <PaziaLoader position="center" />;
  if (!data) return null;

  return (
    <>
      <PageMain className="hidden gap-4 sm:flex sm:flex-col">
        <DashboardNotifications />
        <div className="flex gap-4">
          <MonthCalendar events={events} onMoreEventsClick={onMoreEventsClick} />
          {selected && <SelectedCalendarDayPanel selected={selected} />}
        </div>
      </PageMain>

      <div className="flex h-full sm:hidden">
        <EmptyState
          centerDescription
          title="Nic tu nie ma"
          description="Widok kalendarza jest niedostępny na urządzeniach mobilnych. Przełącz się na komputer, aby zobaczyć kalendarz."
        />
      </div>
    </>
  );
}

function mapEvents(data: CalendarApi): CalendarEvent[] {
  const colorMap = new Map<number, "indigo" | "sky" | "amber" | "rose">();
  const colors: ("indigo" | "sky" | "amber" | "rose")[] = ["indigo", "sky", "amber", "rose"];
  let colorIndex = 0; // Keep track of the next color to assign

  return data.events.map((event) => {
    // Check if the courseId already has a color assigned
    let color = colorMap.get(event.courseId);

    // If no color is assigned, assign the next available color
    if (!color) {
      color = colors[colorIndex];
      colorMap.set(event.courseId, color); // Store the color for the courseId

      // Update the colorIndex, looping back to the beginning if necessary
      colorIndex = (colorIndex + 1) % colors.length;
    }

    // Return the event with the assigned color
    return {
      eventStart: new Date(event.start),
      key: uuidv4(),
      eventEnd: new Date(event.end),
      eventName: event.courseName,
      courseName: event.courseName,
      courseId: event.courseId,
      eventDescription: event.topicName,
      eventColor: color,
      icon: (
        <div>
          <FaLaptop className="mr-1" size={14} />
        </div>
      ),
    };
  });
}
